export function focusQuestionHeading() {
  const headingElement = document.getElementById('question-heading');
  if (headingElement) {
    headingElement.focus();
  }
}

// <label> only allows phrasing content, so flatten the block formats the
// answer editor supports (paragraphs, headings, lists) into inline HTML
export function toLabelHtml(html: string) {
  return html
    .replace(/<(ol|ul)(?:\s[^>]*)?>([\s\S]*?)<\/\1>/g, (_, listTag, items) => {
      let itemNumber = 0;
      return items.replace(/<li(?:\s[^>]*)?>/g, () =>
        listTag === 'ol' ? `${++itemNumber}. ` : '• '
      );
    })
    .replace(/<h[1-6](?:\s[^>]*)?>/g, '<strong>')
    .replace(/<\/h[1-6]>/g, '</strong><br>')
    .replace(/<\/(?:p|li)>/g, '<br>')
    .replace(/<p(?:\s[^>]*)?>/g, '')
    .replace(/(?:\s*<br\s*\/?>\s*)+/g, '<br>')
    .replace(/^<br>|<br>$/g, '');
}
